import React from "react"
import CBN from '../../../../assets/img/cbn-license.inline.svg';
import NDIC from '../../../../assets/img/ndic-license.inline.svg';

const License = props => {
  return (
    <div
      className={`kuda-app--licenses flex align-center ${typeof props.className !== "undefined" ? props.className : ""
        } ${typeof props.hideDownload !== "undefined" ? "mb-0" : ""} `}
    >

      <span className={`single-license ${props.bvn_license ? 'bvn-license' : "" }`}>
        <CBN />
      </span>
      <span className="single-license">
        <NDIC />
      </span>
    </div>
  )
}

export default License
